import { defineMessages } from 'react-intl';

export default defineMessages({

    policyVerification: {
        id: 'twia.fnol.common.views.policy-select-policyholder.Policy Verification',
        defaultMessage: 'Policy Verification',
    },
    providePolicyNumber: {
        id: "twia.fnol.common.views.policy-select-policyholder.Provide Policy Number",
        defaultMessage: "Provide Policy Number"
    },
    searchForAPolicy: {
        id: "twia.fnol.common.views.policy-select-policyholder.Search for a Policy",
        defaultMessage: "Search for a Policy"
    },
    selectPolicyFirstName: {
        id: 'fnol.producer.common.views.policy-select-producer.First Name',
        defaultMessage: 'First Name',
    },
    selectPolicyLastName: {
        id: 'fnol.producer.common.views.policy-select-producer.Last Name',
        defaultMessage: 'Last Name',
    },
    selectPolicyCompanyName: {
        id: 'fnol.producer.common.views.policy-select-producer.Company Name',
        defaultMessage: 'Company Name',
    },
    selectPolicyCity: {
        id: 'fnol.producer.common.views.policy-select-producer.City',
        defaultMessage: 'City',
    },
    selectPolicyState: {
        id: 'fnol.producer.common.views.policy-select-producer.State',
        defaultMessage: 'State',
    },
    selectPolicyZipCode: {
        id: 'fnol.producer.common.views.policy-select-producer.Zip Code',
        defaultMessage: 'Zip Code',
    },
    policyMailingAddress: {
        id: "fnol.producer.common.views.policy-select-producer.Policy Mailing Address",
        defaultMessage: "Policy Mailing Address"
    },
    insuredLocation: {
        id: "fnol.producer.common.views.policy-select-producer.Insured Location - OR -",
        defaultMessage: "Insured Location - OR -"
    },
    streetName: {
        id: "fnol.producer.common.views.policy-select-producer.Street Name",
        defaultMessage: "Street Name"
    },
    streetAddress: {
        id: "fnol.producer.common.views.policy-select-producer.Street Address",
        defaultMessage: "Street Address"
    },
    streetNumber: {
        id: "fnol.producer.common.views.policy-select-producer.Street Number",
        defaultMessage: "Street Number"
    },
    searchBtn: {
        id: "fnol.producer.common.views.policy-select-producer.Search",
        defaultMessage: "Search"
    },
    resetBtn: {
        id: "fnol.producer.common.views.policy-select-producer.Reset",
        defaultMessage: "Reset"
    }
});
